import { ChangeDetectionStrategy, Component, ViewEncapsulation, input } from '@angular/core';
import { EllipsisTooltipDirective } from '@simOn/ui/sim-tooltip';

@Component({
  selector: 'sim-color-badge',
  standalone: true,
  imports: [EllipsisTooltipDirective],
  template: `<span class="sim-color-badge__label" simEllipsisTooltip><ng-content /></span>`,
  styleUrl: './sim-color-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'sim-color-badge',
    '[style.background-color]': 'color()'
  }
})
export class SimColorBadgeComponent {
  readonly color = input<string>('var(--text-icon-lighter)');
}
